import { render } from "./ResultNode.vue?vue&type=template&id=6a0a27a7"
import script from "./ResultNode.vue?vue&type=script&lang=js"
export * from "./ResultNode.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/jdtree-ui/jdtree-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__